import {
  CART_ITEM_SOURCE_TYPES,
  CartItemSourceContext,
  Highlight,
  UserProvider,
} from '@vivino/js-web-common';
import {
  RubyLibExploreVintagesPriceRange,
  RubyLibFullVintage,
  RubyLibFullWine,
  RubyLibMerchant,
  RubyLibMerchantCheckoutPricesAndAvailability,
  RubyLibVintagePrice,
} from '@webtypes/rubyLibApi';
import React from 'react';
import { VintageProvider } from 'vivino-js/context/VintageContext/VintageContext';
import { HighlightTypes, getFilteredHighlights } from 'vivino-js/helpers/highlights';
import Page from 'vivino-js/utilities/Page/Page';

import VintagePage from '@components/VintagePage/VintagePage.presentational';

interface vintagePageInformationType {
  highlights?: Highlight[];
  is_deal: boolean;
  merchant?: RubyLibMerchant;
  price?: RubyLibVintagePrice;
  price_range?: RubyLibExploreVintagesPriceRange;
  prices_and_availability?: RubyLibMerchantCheckoutPricesAndAvailability;
  vintage: RubyLibFullVintage;
  wine: RubyLibFullWine;
  sold_out?: boolean;
  tastes?: any;
}

interface Props {
  user: any;
  promotions: any;
  stateCode: string;
  merchantId: number;
  countryCode: string;
  translations: Record<string, string>;
  vintagePageInformation: vintagePageInformationType;
}

export default ({
  user,
  stateCode,
  merchantId,
  promotions,
  countryCode,
  translations,
  vintagePageInformation,
}: Props) => {
  const priceAndAvailability = vintagePageInformation?.prices_and_availability;
  const availability = priceAndAvailability?.availability;
  const currency = priceAndAvailability?.market?.currency;
  const merchant = vintagePageInformation?.merchant;
  const price = vintagePageInformation?.price;
  const vintage = vintagePageInformation?.vintage;
  const tastes = vintagePageInformation?.tastes;

  const highlights = getFilteredHighlights({
    highlights: vintagePageInformation?.highlights,
    filters: [HighlightTypes.PriceQpr],
  });

  return (
    <Page translations={translations}>
      <UserProvider user={user}>
        <VintageProvider vintage={vintage}>
          <CartItemSourceContext.Provider value={CART_ITEM_SOURCE_TYPES.WINE_PAGE_ROOT}>
            <VintagePage
              price={price}
              tastes={tastes}
              stateCode={stateCode}
              currency={currency}
              merchant={merchant}
              vintage={vintage as any}
              highlights={highlights}
              availability={availability}
              countryCode={countryCode}
              givenMerchantId={merchantId}
              promotions={promotions || []}
              priceRange={vintagePageInformation.price_range || {}}
            />
          </CartItemSourceContext.Provider>
        </VintageProvider>
      </UserProvider>
    </Page>
  );
};
